import type { AxiosInstance } from "axios";
import axios from "axios";

export let apiClient: AxiosInstance;

export function initApiClient(ident: string): void {
  apiClient = axios.create({
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Search-Ident": ident,
    },
  });
}
